import 'css-chunksrc/client/scenes/listRemoval/listsList/list/event/styles.scss';export default {
  "event": "_event_1qj06_1",
  "contextualMenu": "_contextualMenu_1qj06_8",
  "eventDetails": "_eventDetails_1qj06_12",
  "name": "_name_1qj06_22",
  "icon": "_icon_1qj06_38",
  "taskAdvancement": "_taskAdvancement_1qj06_42",
  "taskAdvancementWrapper": "_taskAdvancementWrapper_1qj06_48",
  "removeIcon": "_removeIcon_1qj06_61",
  "status": "_status_1qj06_65",
  "allocations": "_allocations_1qj06_72",
  "text": "_text_1qj06_79",
  "tick": "_tick_1qj06_85",
  "late": "_late_1qj06_92",
  "displayContextualMenu": "_displayContextualMenu_1qj06_103",
  "placeholder": "_placeholder_1qj06_107"
};